<template>
  <div class="app-wrapper">
    <Sidebar class="sidebar-container"></Sidebar>
    <div class="main-container">
      <Navbar></Navbar>
      <AppMain></AppMain>
    </div>
  </div>
</template>

<style scoped>
.app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>

<script>
import { Navbar, Sidebar, AppMain } from '@/views/Admin/Layout'

export default {
  components: {
    Navbar,
    Sidebar,
    AppMain
  }
}
</script>
